<template>
	<div class="desktop-axis-engraving-list">
		<div class="desktop-axis-engraving-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Desktop 5-axis Engraving Machine</span>
			</div>

			<div class="list">
				<img :src="solution_image_01"/>
				<ul>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Support 5-axis vector interpolation \ RTCP tool tip control;</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Spline curve  fairing technology;</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">High-speed forward-looking and speed smoothing technology;</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div
						class="ll x-flow">
							Configure a unique optical scanning module to achieve rapid positioning of the workpiece;
						</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Support virtual processing simulation for quickly verify  of  processing
							procedures;
						</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">
							Support fast CAM programming function, edit functions such as face milling, hole milling and lettering on the machine;
						</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Maximum workpiece size：100mm*100mm*100mm.</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_precision_01.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01
            };
        }
    }

</script>

<style scoped="">
	.dot {
		width: .625rem;
		border: none;
		text-align: left;
	}

	.ll {
		width: calc(100% - .625rem);
		border: none;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
		margin-bottom: 1.375rem;
	}

	.list > img {
		width: 100%;
		margin-bottom: 2rem;
	}

	.list > ul {
		width: 100%;
		height: 21rem;
	}

	.list {
		width: 54.5rem;
		margin-left: 7rem;
	}

	.desktop-axis-engraving-con {
		width: 61.5rem;
		height: 61.5rem;
		margin-left: 0px;
		border: none;
	}

	.desktop-axis-engraving-list {
		width: 100%;
		border: none;
		height: 51rem;
	}

	.x-tit-con {
		font-size: 1.5rem;
		color: #3B3A38;
		line-height: 3.25rem;
	}

	.title {
		width: calc(100% - 3.25rem);
		text-align: left;
		margin-left: 3.25rem;
		margin-top: 2.75rem;
		margin-bottom: 2.75rem;
	}

	.x-icon-keys {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_solutions.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}

	.warnning {

		width: 100%;
		height: 100px;
		margin: 0 auto;
		text-align: center;
		font-style: oblique;
		font-size: 64px;
		font-family: "Open Sans";
		margin-top: 44px;
		margin-bottom: 44px;

	}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-desktop-axis-engraving.vue